import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileArrowLeftIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFileArrowLeftIn"><Path d="M12.3105 19L8.25 23.0605L7.18945 22L9.43945 19.75H3V18.25H9.43945L7.18945 16L8.25 14.9395L12.3105 19Z" fill="currentColor"/><Path d="M12 10H20V21.25C20 21.6642 19.6642 22 19.25 22H11.4316L12.1816 21.25H12.25V21.1816L14.4316 19L12.25 16.8184V16.75H12.1816L8.25 12.8184L5.06836 16H4V2.75C4 2.33579 4.33579 2 4.75 2H12V10Z" fill="currentColor"/><Path d="M19.5605 8.5H13.5V2.43945L19.5605 8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileArrowLeftIn;
